import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { FC, useEffect } from "react";

const MAX_RISK_LEVEL_REASON_LENGTH = 512;

interface IStatusReasonForm {
  riskLevel: string;
  riskLevelReason: string;
  setRiskLevel: React.Dispatch<React.SetStateAction<string>>;
  setRiskLevelReason: React.Dispatch<React.SetStateAction<string>>;
}

const riskLevels = ["Standard", "Elevated", "High"];

export const RiskLevelForm: FC<IStatusReasonForm> = ({
  riskLevel,
  riskLevelReason,
  setRiskLevel,
  setRiskLevelReason,
}) => {
  useEffect(() => {
    setRiskLevel(riskLevels[0]);
  }, [setRiskLevel]);

  return (
    <>
      <FormControl required>
        <InputLabel>Risk Level</InputLabel>
        <Select
          variant='filled'
          name={"riskLevel"}
          label={"Risk Level"}
          value={riskLevel}
          defaultValue={"Standard"}
          renderValue={(value) => value}
          onChange={(e: any) => {
            setRiskLevel(e.target.value);
          }}
        >
          {riskLevels.map((level) => (
            <MenuItem value={level} key={level}>
              {level}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        label='Risk Level Reason'
        name='riskLevelReason'
        size='small'
        margin='normal'
        value={riskLevelReason}
        multiline
        rows={Math.min(10, Math.ceil(riskLevelReason.length / 50))}
        onChange={(e: any) => {
          const filteredValue = e.target.value.replace(/[\r\n]/g, '');
          setRiskLevelReason(filteredValue);
        }}
        inputProps={{
          maxLength: MAX_RISK_LEVEL_REASON_LENGTH,
        }}
      />
    </>
  );
};
